export const EVENT_SOURCE = 'onboarding';
export const LEARN_MORE_URL =
	'https://support.atlassian.com/confluence-cloud/docs/manage-your-storage-usage/';
